/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Formats an elapsed time in seconds to a human-readable duration string.
 *
 * - If total duration < 1 hour → `"MM:SS"` (e.g., `"30:00"`, `"02:15"`)
 * - If total duration >= 1 hour → `"HH:MM:SS"` (e.g., `"01:30:00"`)
 *
 * Used for Start Over mode time labels where elapsed time (not wall-clock)
 * is displayed.
 *
 * @param seconds - Total elapsed seconds (non-negative).
 * @returns Formatted duration string.
 */
export function formatElapsedTime(seconds: number): string {
  if (seconds < 0 || !isFinite(seconds)) {
    return "00:00";
  }

  const totalSeconds: number = Math.floor(seconds);
  const hours: number = Math.floor(totalSeconds / 3600);
  const minutes: number = Math.floor((totalSeconds % 3600) / 60);
  const secs: number = totalSeconds % 60;

  const mm: string = String(minutes).padStart(2, "0");
  const ss: string = String(secs).padStart(2, "0");

  if (hours > 0) {
    const hh: string = String(hours).padStart(2, "0");
    return hh + ":" + mm + ":" + ss;
  }

  return mm + ":" + ss;
}
